import React from 'react'
import { useContext } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import BookTripDetails from './BookTripDetails'
import BookTripFlextime from './BookTripFlextime'
import MyLocation from '../comps/MyLocation.js'
import TripInfo from '../comps/TripInfo'
import {AppContext} from '../context/AppContext'

const BookTripFooter = () => {
  let match = useRouteMatch()
  const location = useLocation()
  console.log(match.path)

  const {tripDetails, prevPage, setPrevPage, nextPage, setNextPage, infoShow, setInfoShow} = useContext(AppContext)

  return (
    <footer className={nextPage ==  "/booktrip/done" ? "booking-footer confirm" : "booking-footer"}>
          <TripInfo/>
          <div className="button-group prev-next-buttons">
                <Link to={prevPage} className="button button-prev"><h3>Back</h3></Link>
                <Link to={nextPage} className="button button-next"><h3>{nextPage ==  "/booktrip/done" ? "Confirm" : "Next"}</h3></Link>
          </div>
    </footer>
  )
}

export default BookTripFooter
